import {Observable} from 'rxjs';
import {HttpService} from '@services/http.service';
import {environment} from '@env/environment';
import {Injectable} from '@angular/core';
import {
  DocumentTypeListResponse,
  ExerciseTypeListResponse, ImsDocumentsListResponse,
  LoginResult, ProcedureDetailResponse,
  ProcedureListResponse,
  RequestCreateResponse,
  RequestDetailResponse,
  RequestIntegrateResponse,
  RequestMailListResponse,
  RequestTypeListResponse,
  ImsDocumentDetailListResponse, TypeResponse, ImsDocumentDetaiLDownload, TagsResponse
} from '../models/output.model';
import {
  CreateTypeInput,
  HRRequestListInput,
  ImsDocumentsInputs,
  IntegrateTypeInput,
  LoginParams,
  Procedures
} from '../models/input.model';



@Injectable({
  providedIn: 'root'
})
export class ApiService {


  constructor(
    private http: HttpService
  ) {
  }

  public login(params: LoginParams): Observable<LoginResult> {
    return this.http.post(environment.api.BE + environment.api.endpoints.login, {params});
  }

  public getRequest(id: string): Observable<RequestDetailResponse> {
    return this.http.get(environment.api.BE + environment.api.BEVersion + environment.api.endpoints.hrRequest(id));
  }

  public getRequests( data: HRRequestListInput | {} ): Observable<RequestMailListResponse> {
    return this.http.post(environment.api.BE + environment.api.BEVersion + environment.api.endpoints.hrRequestList, {params:data});
  }

  public integrateRequest(data: IntegrateTypeInput): Observable<RequestIntegrateResponse> {
    return this.http.post(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.integrate, {params:data})
  }

  public createRequest(data: CreateTypeInput): Observable<RequestCreateResponse> {
    return this.http.post(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.create, {params:data})
  }

  public getExerciseTypes(): Observable<ExerciseTypeListResponse> {
    return this.http.get(environment.api.BE + environment.api.BEVersion + environment.api.endpoints.exercises);
  }
  public getRequestTypes() : Observable<RequestTypeListResponse> {
    return this.http.get(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.requests);
  }
  public getAdminTypes() : Observable<TypeResponse> {
    return this.http.get(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.ctmType);
  }

  public getUserRequestTypes() : Observable<TypeResponse> {
    return this.http.get(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.userRequestType);
  }

  public getAdminTags() : Observable<TagsResponse> {
    return this.http.get(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.ctmTags);
  }

  public getDocument(id: number): Observable<ImsDocumentDetaiLDownload> {
    return this.http.get(environment.api.BE + environment.api.BEVersion +environment.api.endpoints.documentContent(id))
  }

  public getDocumentTmp(id: number) {
    return this.http.get(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.docstemp(id))
  }

  public getProcedures(data: Procedures | {} ): Observable<ProcedureListResponse> {
    return this.http.post(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.procedures, {params:data});
  }

  public getProcedure(id: number): Observable<ProcedureDetailResponse> {
    return this.http.get(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.procedure(id));
  }

  public getImsDocuments(data: ImsDocumentsInputs | {} ): Observable<ImsDocumentsListResponse> {
    return this.http.post(environment.api.BE + environment.api.BEVersion + environment.api.endpoints.documents, {params:data});
  }
  public getImsDocumentDetail(id: number  ): Observable<ImsDocumentDetailListResponse> {
    return this.http.get(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.documentDetail(id));
  }

  public getImsDocumentTypes(): Observable<DocumentTypeListResponse> {
    return this.http.get(environment.api.BE+ environment.api.BEVersion +environment.api.endpoints.documentTypes);
  }



}
